// extracted by mini-css-extract-plugin
export var fulfillmentPanel = "_hp-0";
export var fulfillmentPanelBody = "_hp-1";